var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',_vm._b({},'v-icon',_vm.iconProps,false),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.icon))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }